import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getAssociationMembers } from "../services/association-member";

export function useGetAssociationMembers() {
  return useQuery({
    queryKey: ["associationMembers"],
    queryFn: () => getAssociationMembers(),
    staleTime: 1000 * 60 * 5,
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
